import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import ApproveModal from '../../app/common/modals/ApproveModal';
import { Activity } from '../../app/models/activity';
import ReportsModal from '../TableReports/ReportsModal';
import DynamicTableComponent from './DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { useStore } from '../../app/stores/store';

function FilmFestivalReport() {
  const { dashboardStore, reportStore, commonStore } = useStore();
  const { userReadableDateFormat } = commonStore;
  const { filmFestivalByDate, loadFilmFestivalPagination } = reportStore;
  const [pageNumber, setPageNumber] = useState(1);

  useEffect(() => {
    dashboardStore.InventoryCountData();
    loadFilmFestivalPagination(1);
    // eslint-disable-next-line
  }, []);

  const tableData: Activity[] = [];

  filmFestivalByDate.forEach((a) => {
    tableData?.push({
      ...a,
      movementdate: userReadableDateFormat(a.movementdate),
      movement_Time: userReadableDateFormat(a.movement_Time),
      maintenance: userReadableDateFormat(a.maintenance),
      receivingdate: userReadableDateFormat(a.receivingdate),
      status_Time: userReadableDateFormat(a.status_Time),
      itemCreatedAt: userReadableDateFormat(a.itemCreatedAt),
    });
  });
  const createOrderFilter = tableData?.filter((x) => x?.isReceiving === false);
  const MainFilter =
    dashboardStore.dashboard.L2CardValueInventory === 'Receiving' &&
    dashboardStore.dashboard.valueForL3Inventory === 'Create Order Receiving'
      ? createOrderFilter
      : tableData;

  const removeCol =
    'isReceiving,isDelivery,isReceivingOrder,files,assignedUsers,comments,itemHistory,orders,itemDeliveryRequest,inwards,typeid,thumbnail,preview,proxy,global_positioning_system,isHost,elementtypeid,receivings,host,isDeleted,isActive,cast,thumbnail_large,thumbnail_small,groove_type,speed_and_speed_adjustment,number_of_channels_and_sound_channel_map,file_format_name_and_version,analog_media,format_in_terms_of_broadcast_standards,bits_per_sample_and_sampling_description,songs,physcial_format,host,hostUsername,originIndia,itemCreatedAt,inactive,isgoing,ishost,clearedon';
  const assettable = JSON.parse(JSON.stringify(MainFilter));
  assettable.map((i: any) => removeCol.split(',').map((j) => delete i[j]));

  const paginateFunction = (e: number) => {
    loadFilmFestivalPagination(e);
    setPageNumber(e);
  };
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  //  if (!loadActivitiesPagination ) return <LoadingComponent />;
  // const assetTableData=
  return (
    <div>
      {dashboardStore.dashboard.DenialModal === true ? (
        <ApproveModal />
      ) : dashboardStore.dashboard.reportsConfiguration === true ? (
        <ReportsModal
          toggleProps={dashboardStore.dashboard.tableconfigurationClicked}
        />
      ) : null}

      <DynamicTableComponent
        key={uuid()}
        data={assettable}
        name={'FilmFestivalReport'}
        actiontype={''}
        pageFunc={paginateFunction}
        pageNumData={pageNumber}
        searchFuncData={searchFunction}
        loading={!loadFilmFestivalPagination}
      />
    </div>
  );
}
export default observer(FilmFestivalReport);
